import http from '../_http'

//billing api - group
const billing_group = {
  //payment credit
  creditGroup: (m) => { return http.post(`manager/billing/group/payment/credit`, m); },
}

export default billing_group